export const SET_Mobile = 'SET_Mobile'
export const SET_LOGIN_DRAWER = 'SET_LOGIN_DRAWER'
export const SET_SIGNUP_DRAWER = 'SET_SIGNUP_DRAWER'
export const SET_FORGET_PASSWORD_DRAWER = 'SET_FORGET_PASSWORD_DRAWER'
export const GET_HOMEPAGE = 'GET_HOMEPAGE'
export const GET_HOMEOTHERS = 'GET_HOMEOTHERS'
export const GET_ESSENTIALS = 'GET_ESSENTIALS'
export const GET_A_CHANNEL = 'GET_A_CHANNEL'
export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL'
export const RESET_CURRENT_CHANNEL = 'RESET_CURRENT_CHANNEL'
export const RESET_ARTICLES = 'RESET_ARTICLES'
export const GET_ARTICLES = 'GET_ARTICLES'
export const GET_AN_ARTICLE = 'GET_AN_ARTICLE'
export const GET_RELATED_ARTICLES = 'GET_RELATED_ARTICLES'
export const SET_ARTICLE_EVENT_PARTICIPATION = 'SET_ARTICLE_EVENT_PARTICIPATION'
export const GET_RECOMMENDS = 'GET_RECOMMENDS'
export const GET_ARTICLE_COMMENTS = 'GET_ARTICLE_COMMENTS'
export const GET_TRIAL_COMMENTS = 'GET_TRIAL_COMMENTS'
export const GET_LECTURE_COMMENTS = 'GET_LECTURE_COMMENTS'
export const GET_VOTE_COMMENTS = 'GET_VOTE_COMMENTS'
export const SET_ARTICLE_COMMENT = 'SET_ARTICLE_COMMENT'
export const SET_TRIAL_ITEM_COMMENT = 'SET_TRIAL_ITEM_COMMENT'
export const SET_LECTURE_COMMENT = 'SET_LECTURE_COMMENT'
export const SET_VOTE_COMMENT = 'SET_VOTE_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const GET_VIDEOS = 'GET_VIDEOS'
export const GET_A_VIDEO = 'GET_A_VIDEO'
export const GET_PRIZES = 'GET_PRIZES'
export const GET_POINT_RECORDS = 'GET_POINT_RECORDS'
export const SET_POINTS = 'SET_POINTS'
export const GET_EVENT_RECORDS = 'GET_EVENT_RECORDS'
export const GET_ANNOUNCES = 'GET_ANNOUNCES'
export const GET_AN_ANNOUNCE = 'GET_AN_ANNOUNCE'
export const GET_SPECIALS = 'GET_SPECIALS'
export const GET_TRIALS = 'GET_TRIALS'
export const GET_A_TRIAL = 'GET_A_TRIAL'
export const SET_TRIAL_PARTICIPATION = 'SET_TRIAL_PARTICIPATION'
export const GET_LECTURES = 'GET_LECTURES'
export const GET_A_LECTURE = 'GET_A_LECTURE'
export const SET_LECTURE_PARTICIPATION = 'SET_LECTURE_PARTICIPATION'
export const GET_VOTES = 'GET_VOTES'
export const GET_A_VOTE = 'GET_A_VOTE'
export const VOTE_OPTION = 'VOTE_OPTION'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const RESET_USER_ID = 'RESET_USER_ID'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'
export const GET_PROFILE = 'GET_PROFILE'
export const GET_COLLECTIONS = 'GET_COLLECTIONS'
export const ADD_COLLECTION = 'ADD_COLLECTION'
export const REMOVE_COLLECTION = 'REMOVE_COLLECTION'
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS'
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION'
export const REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION'
export const SET_404_NOT_FOUND = 'SET_404_NOT_FOUND'
export const SET_500_ERROR = 'SET_500_ERROR'
export const GET_AUTHORS = 'GET_AUTHORS'
export const GET_AN_AUTHOR = 'GET_AN_AUTHOR'
export const GET_NOTICES = 'GET_NOTICES'
export const READ_NOTICE = 'READ_NOTICE'
export const SET_VIA = 'SET_VIA'
export const BIND_VISIBLE = 'BIND_VISIBLE'
export const APP_VERSION = 'APP_VERSION'
export const UPDATE_SHOW_YELLOW_TIP = 'UPDATE_SHOW_YELLOW_TIP'
export const UPDATE_YELLOW_TIP = 'UPDATE_YELLOW_TIP'
export const UPDATE_NOTICES_COUNT = 'UPDATE_NOTICES_COUNT'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
export const SET_PRIZE_INFO = 'SET_PRIZE_INFO'
export const APP_UPDATE_TIP = 'APP_UPDATE_TIP'
export const GET_EXPIRE_POINTS = 'GET_EXPIRE_POINTS'
